<template>
  <div id = "new-classroom" class = "modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Nueva clase</p>
    </header>

    <section class="modal-card-body auth-decider-container">
      <!-- create classroom -->
      <div v-if = "successCreateClassroom === 0 || successCreateClassroom === -1">
        <section>
          <div class="forms-container">
            <b-field label="Nombre de la clase" :type="formsMngmnt.name_type" :message="formsMngmnt.name_message">
              <b-input type="text" v-model="inputs.name"  id="nameField" placeholder="por ejemplo 1º B."  ref="nameField" required> </b-input>
            </b-field>

            <b-field label="Descripción" :type="formsMngmnt.description_type" :message="formsMngmnt.description_message">
              <b-input type="text" v-model="inputs.description"  id="descriptionField" placeholder="Descripción"  ref="descriptionField"> </b-input>
            </b-field>

            <b-field class="institution" label="¿A que institución pertenece esta clase?" :message="formsMngmnt.institution_message"  :type="formsMngmnt.institution_type">
              <b-autocomplete expanded class="onlyline autocomplete-insititution"
                v-model="inputs.institution"
                :data="filteredDataArrayInstitutions"
                placeholder="Elige de la lista o escribe una nueva"
                :open-on-focus="keepfirst"
                icon="magnify" field="name"
                :keep-first="keepfirst"
                @select="institutionSelectedEvent"
                ref="institutionfield">
                  <template slot="header">
                    <a @click="addInstitution">
                      <span>Añadir institución</span>
                    </a>
                </template>
                <template slot="empty">No hay resultados. Escribe tú el nombre</template>
              </b-autocomplete>
            </b-field>
            <new-institution v-if = "isShowingAddInstitution"></new-institution>
          </div>
        </section>
      </div>

      <!-- created -->
      <div v-else-if = "successCreateClassroom === 1">
        <section class="">
          Hemos creado una clase con los siguientes datos:
          <ul>
            <li><strong> Nombre: </strong>      {{inputs.name}}        </li>
            <li><strong> Descripción: </strong> {{inputs.description}}</li>
            <li><strong> Institución: </strong> {{inputs.institution}}</li>
          </ul>
          <div class="has-text-centered" style="margin:3em 1em;">
            Tienes que dar el siguiente código a tus alumnos para que se inscriban
            <h1> {{createClassroomResponse.data.code}} </h1>
            <span class="is-size-7"> (No hace falta que lo anotes, puedes consultarlo en cualquier momento) </span>
          </div>
          <div class="has-text-centered">
            <a class="btn btn-bg-colored" v-on:click="$emit('closeNewClassroomAndRefresh')"> ¡Entendido! </a>
          </div>
        </section>
      </div>
    </section>

    <footer class="modal-card-foot">
      <button class = "btn" type="button" @click="$parent.close()">Cerrar</button>
      <button class="btn btn-bg-colored" v-on:click="createClass"> Crear clase</button>
    </footer>
  </div>
</template>
<script>
import NewInstitution from './NewInstitution'
export default {
  name: 'NewClassRoom',
  components: {
    NewInstitution
  },
  data: () => ({
    inputs: {
      name: '',
      description: '',
      institution: ''

    },
    formsMngmnt: {
      name_message: '',
      name_type: '',
      description_message: '',
      description_type: '',
      institution_message: '',
      institution_type: ''
    },
    successCreateClassroom: 0,
    createClassroomResponse: {},
    keepfirst: true,
    institutionSelected: '',
    isShowingAddInstitution: false
  }),
  methods: {
    institutionSelectedEvent (option) {
      console.log(option.id)
      this.institutionSelected = option.id
    },
    createClass () {
      this.$store.dispatch('user/addClassroom',
        {'name': this.inputs.name, 'description': this.inputs.description, 'owner': this.$store.state.auth.userid, 'institution': parseInt(this.institutionSelected)})
        .then(response => {
          this.successCreateClassroom = 1
          this.createClassroomResponse = response
        }).catch(error => {
          console.log(error.response.data)
          this.successCreateClassroom = -1
          this.createClassroomResponse = error
          this.formsMngmnt.institution_message = error.response.data.detail
          // this.formsMngmnt.name_type = 'is-danger'
        })
    },
    addInstitution () {
      this.isShowingAddInstitution = true
    },
    addedInstitution (newInstitution) {
      this.showAddInstitution = false
      this.$store.dispatch('user/fetchInstitutions')
        .then((error) => {
          console.log(error)
          this.$refs.institutionfield.setSelected(newInstitution)
        })
    }
  },
  computed: {
    getInstitutionList () {
      return this.$store.state.user.institutions
    //  return [{name: 'IE Universidad', id: '0'}, {name: 'Universidad 2', id: '1'}]
    },
    filteredDataArrayInstitutions () {
      return this.getInstitutionList.filter((option) => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(this.inputs.institution.toLowerCase()) >= 0
      })
    }
  },
  created () {
    this.$store.dispatch('user/fetchInstitutions')
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/styles/main.less";
</style>



// WEBPACK FOOTER //
// src/components/User/NewClassroom.vue